export default __webpack_public_path__ + "static/Swiss721BT-Light-74d89efce5e91e79111b20e001a40415.eot";